import { Card, Row, Spin } from "antd";
import { memo, useCallback, useState } from "react";
import { IntervalSelector } from "../IntervalSelector";
import { Line } from "@ant-design/plots";
import { DefaultLegend } from "../DefaultLegend";
import { CHART_DEFAULT, CHART_PAID_OFF } from "../../../../lib/constants";
import { useFetchData } from "./hooks/useFetchData";
import { useDoubleLineChartConfig } from "../../hooks/useDoubleLineChartConfig";

type PortalVisitsProps = {
  visits: any;
  isDataLoading: boolean;
  isRecalculated: boolean;
};

const PortalVisits = ({
  visits,
  isDataLoading,
  isRecalculated,
}: PortalVisitsProps) => {
  const [granularity, setGranularity] = useState<number>(1);

  const { data, isLoading } = useFetchData(granularity, isRecalculated);

  const getColor = useCallback(({ type }: { type: string }): string => {
    return type === "All Unique Visitors" ? CHART_PAID_OFF : CHART_DEFAULT;
  }, []);

  const { config } = useDoubleLineChartConfig(data, getColor);

  return (
    <Card className="dashboard-card top">
      <Row className="justify-space-between align-center">
        <p className="text my-0">Portal Visits</p>
        <IntervalSelector value={granularity} onSelect={setGranularity} />
      </Row>
      <Row className="d-block h-100">
        {!isDataLoading && !isLoading ? (
          <Row className="d-block">
            <Row className="mb-6 mt-2">
              <Row className="d-block mr-6">
                <h3 className="h h3">{visits[granularity].unique}</h3>
                <p className="my-0 text-sm title">all unique visits</p>
              </Row>
              <Row className="d-block">
                <h3 className="h h3">{visits[granularity].firstTime}</h3>
                <p className="my-0 text-sm title">first-time visitors</p>
              </Row>
            </Row>

            <Line {...config} />

            <DefaultLegend
              first="All Unique Visits"
              second="First-Time Visitors"
            />
          </Row>
        ) : (
          <Row className="h-100 justify-center align-center">
            <Spin size="large" />
          </Row>
        )}
      </Row>
    </Card>
  );
};

export default memo(PortalVisits);
